import { inject, Injectable } from '@angular/core';
import { Item } from '@softapps/handel/esl/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_ESL_ASSOCIATE, SOFTLINE_API_ESL_DISSOCIATE } from '../esl-link.api';

@Injectable()
export class EslLinkAssociateService {
  readonly dataAccess = inject(ApiDataAccess);

  associate(eslCode: string, items: Item[]): Promise<void> {
    const itemList = items.map((o) => ({
      idartstamm: o.id,
      idmanartikeldat: o.idmanartikeldat,
      idarteh: o.idarteh,
    }));
    return this.dataAccess.create(
      { path: SOFTLINE_API_ESL_ASSOCIATE },
      { eslCode, itemList }
    );
  }

  dissociate(eslCode: string): Promise<void> {
    return this.dataAccess.create({ path: SOFTLINE_API_ESL_DISSOCIATE }, { eslCode });
  }
}
